import * as Yup from "yup"

const CompositionFormValidationShema = Yup.object().shape({
  selectedCompany: Yup.object().typeError("Company is required."),
  productName: Yup.string().required("Product name is required."),
  productId: Yup.string().required("Product id is required."),
})

export default CompositionFormValidationShema
